import React from 'react';
// Constants
import {
  CompanyName,
  CompanyPhoneNumber,
  CompanyTagLine,
  LocationCity,
  MainTitle,
} from '../../utils/Constants';
// Images
import MainImage from '../../assets/images/main/mistress-md-professional-dominatrix-main-image.jpg';
import LeftCross from '../../assets/images/logos/mistress-md-professional-dominatrix-cross-logo-right-side-no-background.png';
import RightCross from '../../assets/images/logos/mistress-md-professional-dominatrix-cross-logo-left-side-no-background.png';

function HomePageHeader() {
  return (
    <header className='grid w-full'>
      <div className='grid px-2 sm:px-10 md:px-16 pt-10'>
        <article className='grid text-center gap-2'>
          <h1 className='font-StencilW01 text-[2.5rem] xs:text-5xl md:text-6xl lg:text-8xl xl:text-9xl text-colour5 dark:text-colour5 font-medium tracking-widest uppercase'>
            {CompanyName}
          </h1>
          <h2 className='text-lg md:text-2xl'>{MainTitle}</h2>
          <h3 className='text-xs lg:text-lg'>
            🔞 ADULT CONTENT - NOT SUITABLE FOR UNDER 18's 🔞
          </h3>
          <div>
            <p className='text-colour5 dark:text-colour5 text-xl lg:text-3xl font-StencilW01'>Available in {LocationCity}</p>
          </div>
          <div className='px-4 pt-4'>
            <div className='bg-colour5 shadow-cardShadowBold dark:bg-colour5 rounded-tl-2xl rounded-tr-2xl relative px-2 py-2 mx-auto w-fit'>
              <img
                src={MainImage}
                alt={`${CompanyName} ${CompanyTagLine}`}
                className='w-full max-w-lg rounded-tl-2xl rounded-tr-2xl mx-auto h-auto'
              />
              <div className='absolute left-1/2 top-1/2 transform w-full -translate-x-1/2 -translate-y-1/2'>
                <span className='font-StencilW01 text-5xl w-full text-colour1 dark:text-colour1'>
                  JOIN ME
                </span>
                <div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
      <section className='grid lg:grid-cols-a1a gap-4 pt-12 lg:pt-16 text-lg'>
        <div className='hidden lg:grid'>
          <img src={LeftCross} alt='Left cross' />
        </div>
        <div className='grid gap-4 px-6 sm:px-10 md:px-16 text-center'>
          <p>
            <strong className='text-colour5 dark:text-colour5'>Step into</strong> the sanctuary of
            the
            <em> enigmatic Dominatrix</em>, where the sterile scent of a
            hospital ward gives way to the heady perfume of{' '}
            <strong className='text-colour5 dark:text-colour5'>power and control</strong>. I am your clandestine caregiver,
            a <em>registered nurse</em> with hands that heal in my vanilla world
            but harbor a <strong className='text-colour5 dark:text-colour5'>secret sadistic passion</strong> for the
            perverse and kinky.
          </p>

          <p>
            As my night shifts draw to an end, I transform into the{' '}
            <strong className='text-colour5 dark:text-colour5'>sovereign of sensual degradation</strong>,{' '}
            <em>sploshing empress</em>, and a formidable force in the field of{' '}
            <strong className='text-colour5 dark:text-colour5'>session wrestling</strong>.
          </p>

          <p>
            In my private quarters, a{' '}
            <strong className='text-colour5 dark:text-colour5'>realm of submission and service</strong> awaits those brave
            enough to kneel before me. Here, the submissive find solace in
            <em>{' '}surrender</em>, worshiping at the altar of my dominion. With
            each session, I weave a <strong className='text-colour5 dark:text-colour5'>tapestry of fantasies</strong>,
            inviting you to explore the depths of your desires and the limits of
            your endurance.
          </p>

          <p>
            As a <strong className='text-colour5 dark:text-colour5'>Session Wrestler</strong>, I engage in a{' '}
            <em>primal dance of strength and strategy</em>, where your attempts
            to overpower me only fuel my triumph. Feel the intoxicating blend of
            my <strong className='text-colour5 dark:text-colour5'>physical prowess</strong> and your
            <em>{' '}futile resistance</em> as I pin you down, my muscles flexing
            with every victory.
          </p>

          <p>
            In the realm of <strong className='text-colour5 dark:text-colour5'>Sploshing</strong>, I reign supreme,
            delighting in the
            <em>{' '}messy marriage of food and fetish</em>. Watch as I play with my
            prey, covering you in a cascade of{' '}
            <strong className='text-colour5 dark:text-colour5'>creamy confections</strong>, transforming you into a
            <em>{' '}canvas of culinary chaos</em>.
          </p>
        </div>
        <div className='hidden lg:grid'>
          <img src={RightCross} alt='Right cross' />
        </div>
      </section>
    </header>
  );
}

export default HomePageHeader;
